<!--
	Presmerovanie na obrazovku so súhrnnými informáciami
-->

<script lang="ts">
	import { navigate } from "svelte-navigator";

	navigate("/main/summary");
</script>